import { useEffect, useState, useRef } from "react"

import Button from '@mui/material/Button'
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import InputGroup from 'react-bootstrap/InputGroup'

import { IoIosAddCircleOutline } from "react-icons/io";
import { RiAiGenerate2 } from "react-icons/ri";
import { FaTrashAlt } from "react-icons/fa";

import { SettingsGroup } from "../../../Modules/General"
import FontModule from "../../../Modules/FontModule"
import VariableModule from "../../../Modules/VariableModule"

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import LinearProgress from '@mui/material/LinearProgress';

import { backendAccessPost } from '../../../../../Utils/Authentication'

import * as Basic from "../../../Modules/BasicFields"

const triviaKingVariables = [
    {name:'Output', key:'output', type:'W'},
]

export const Question = ( props ) => {
    const itemIdx = props.itemIdx 
    const items = props.items 
    const setItems = props.setItems

    const [ q, setQ] = useState(items[itemIdx].question || "")
    const [ a1, setA1 ] = useState(items[itemIdx].answer1 || "")
    const [ a2, setA2 ] = useState(items[itemIdx].answer2 || "")
    const [ a3, setA3 ] = useState(items[itemIdx].answer3 || "")
    const [ a4, setA4 ] = useState(items[itemIdx].answer4 || "")

    useEffect( () => {
        setQ( items[itemIdx].question || "" )
        setA1( items[itemIdx].answer1 || "" )
        setA2( items[itemIdx].answer2 || "" )
        setA3( items[itemIdx].answer3 || "" )
        setA4( items[itemIdx].answer4 || "" )
    },[ items ])
     
    useEffect( () => {
        let item = structuredClone( items[itemIdx] )
        
        item.question = q 
        item.answer1 = a1 
        item.answer2 = a2 
        item.answer3 = a3 
        item.answer4 = a4 

        if( JSON.stringify(item) != JSON.stringify(items[itemIdx]) )
        {
            let ii = structuredClone(items)
            ii[itemIdx] = item 
            setItems(ii)
        }
    },[q,a1,a2,a3,a4])

    const removeQuestion = () => {
        if( !window.confirm("Are you sure you want to remove the question?") )
        {
            return
        }

        let ii = structuredClone(items)
        ii.splice( itemIdx,1 )
        setItems(ii)
    }

    return (
        <div style={{ marginBottom:'10px'}}>
            
            <div style={{fontSize:12, width:'100%', height:'30px'}}>
                <div className="d-flex align-items-center" style={{ float:'left', height:'100%'}}>
                Question {itemIdx+1}
                </div>
                <div className="d-flex align-items-center" style={{ float:'right', height:'100%'}}>
                    <Button size="small" color="error" onClick={removeQuestion}><FaTrashAlt/></Button>
                </div>

            </div>
            <div className="d-flex justify-content-center align-items-center"
                 style={{width:'100%', height:'30px', marginBottom:'5px'}} >
                <Form.Control value={q} 
                          onChange={ e => setQ(e.target.value)} 
                          size="sm"
                          placeholder="Question title"
                />
            </div>
            <div style={{width:'100%', height:'30px', marginBottom:'5px'}} >
                <div style={{ float:'right', height:'100%', width:'90%', display:'flex', alignItems:'center'}}>
                    <Form.Control value={a1} 
                          onChange={ e => setA1(e.target.value)} 
                          size="sm"
                          style={{ width:'100%'}}
                          placeholder="Answer 1"
                    />
                </div>
            </div>
            <div style={{width:'100%', height:'30px', marginBottom:'5px'}} >
                <div style={{ float:'right', height:'100%', width:'90%', display:'flex', alignItems:'center'}}>
                    <Form.Control value={a2} 
                                  onChange={ e => setA2(e.target.value)} 
                                  size="sm"
                                  style={{ width:'100%' }}
                                  placeholder="Answer 2"
                    />
                </div>
            </div>
            <div style={{width:'100%', height:'30px', marginBottom:'5px'}} >
                <div style={{ float:'right', height:'100%', width:'90%', display:'flex', alignItems:'center'}}>

                    <Form.Control value={a3} 
                          onChange={ e => setA3(e.target.value)} 
                          size="sm"
                          style={{ width:'100%' }}
                          placeholder="Answer 3"
                    />
                </div>
            </div>
            <div style={{width:'100%', height:'30px', marginBottom:'5px'}} >
                <div style={{ float:'right', height:'100%', width:'90%', display:'flex', alignItems:'center'}}>
                    <Form.Control value={a4} 
                                  onChange={ e => setA4(e.target.value)} 
                                  size="sm"
                                  style={{ width:'100%' }}
                                  placeholder="Answer 4"
                    />
                </div>
            </div>
        </div>
    )
}

export const QuestionsBank = ( props ) => {
    const questions = props.questions 
    const setQuestions = props.setQuestions

    const [ items, setItems ] = useState(null)

    const requiredData = [
        items
    ]

    useEffect( () => {
        setItems( questions.items || [] )
    },[])

    const addQuestion = () => {
        let qq = structuredClone(items)
        qq.push({})
        setItems(qq)
    }

    useEffect( () => {
        if( requiredData.includes(null) )
        {
            return
        }

        let qq = structuredClone(questions)
        qq.items = items
        setQuestions(qq)
    },[ items ] )

    if( requiredData.includes(null) )
    {
        return <></>
    }

    return (
        <div style={{ height:'600px', width:'100%', overflowY:'scroll', padding:'10px'}}>
            { items.map( (item,idx) =>
            <Question itemIdx={idx} items={items} setItems={setItems} key={idx}/>
            )}
            <div className="d-flex justify-content-center align-items-center" 
                     style={{ width:'100%', height:'30px' }}
            >
                <Button style={{ width:'140px', 
                                         float:'left', 
                                         textTransform:'none' 
                                      }}
                                size="small"
                                onClick={addQuestion}
                >
                    <IoIosAddCircleOutline/> Add question
                </Button>
            </div>

        </div>
    )
}

export function AiGenerate( props )
{
    const questions = props.questions 
    const setQuestions = props.setQuestions

    const [ items, setItems ] = useState(null)
    const [ token, setToken ] = useState(null)
    const [ aiItems, setAiItems ] = useState(null)
    const [ lastAiTag, setLastAiTag ] = useState(null)

    const [ prompt, setPrompt ] = useState("")
    const [ generating, setGenerating ] = useState(false)

    const initliazed = useRef(false)

    const requiredData = [
        items,
        aiItems,
        lastAiTag
    ]

    useEffect( () => {
        setItems( questions.items || [] )
        setAiItems( questions.ai_items || [] )
        setLastAiTag( questions.last_ai_tag || "" )
        setToken( questions.token || "" )
        setPrompt("")
        setGenerating(true)
    },[])

    useEffect( () => {

        console.log( token, lastAiTag, aiItems )
        if( token == null || lastAiTag==null || aiItems==null )
        {
            return
        }

        if( initliazed.current )
        {
            return
        }

        if( token != "" )
        {
            fetch()
        }   
        else 
        {
            setGenerating(false)
        }

        initliazed.current = true


    },[ token, lastAiTag, aiItems ])

    const fetch = () => {
        let data = {}
        data.token = token

        backendAccessPost('/api/llm/fetch/', data).then( res => {
            if( res.error_message )
            {
                alert( res.error_message )
                return
            }

            console.log(res)

            if( res.token == token && res.status == "done" )
            {
                console.log(res)
                let ii = structuredClone(aiItems)

                const outputs = res.outputs.model_output
                const tag = res.outputs.tag

                if( tag == lastAiTag )
                {
                    console.log("Nothing to do here!")
                    setGenerating(false)
                    return
                }

                for( let q of outputs.questions )
                {
                    let qq = {}
                    qq.question = q.question 
                    qq.answer1 = q.options[0]
                    qq.answer2 = q.options[1]
                    qq.answer3 = q.options[2]
                    qq.answer4 = q.options[3]

                    ii.push(qq)
                }

                setAiItems(ii)
                setLastAiTag( tag )
                setGenerating(false)
            }
        })
    }

    const submit = () => {
        if( prompt == "" )
        {
            alert("Prompt cannot be empty.")
            return
        }

        let data = {}

        if( token == "" )
        {
            data.system_message = 'You are an expert in generating trivia questions. First, think about the questions carefully and respect the language of the user and ONLY answer in that language. Then, provide the final output ONLY in valid JSON format.'
            data.output_format = 'The format must be exactly like this:{"questions": [{"id": 1,"question": "Question text here","options": ["A", "B", "C", "D"],"answer": "Correct Option"}]}'
        }
        else 
        {
            data.token = token
        }

        data.user_prompt = prompt

        backendAccessPost('/api/llm/submit/', data).then( res => {
            if( res.error_message )
            {
                alert( res.error_message )
                return
            }

            setToken(res.token)
            setGenerating(true)
        })
    }
 
    useEffect( () => {
        if( requiredData.includes(null) )
        {
            return
        }

        let qq = structuredClone(questions)
        qq.items = items 
        qq.ai_items = aiItems
        qq.last_ai_tag = lastAiTag

        if( token != null )
        {
            qq.token = token
        }

        if( JSON.stringify(qq) != JSON.stringify(questions) )
        {
            setQuestions(qq)
        }

    },[items, aiItems, token, lastAiTag])

    if( requiredData.includes(null) )
    {
        return <></>
    }

    return (
        <div style={{ height:'600px', width:'100%', overflowY:'scroll', padding:'10px'}}>
            { aiItems.map( (item,idx) =>
            <Question itemIdx={idx} items={aiItems} setItems={setAiItems} key={idx}/>
            )}
            <div className="d-flex justify-content-center align-items-center" 
                     style={{ width:'100%', height:'30px' }}
            >
                { !generating &&
                <InputGroup style={{ width:'500px'}}>
                    <Form.Control value={prompt} 
                                  onChange={e => setPrompt(e.target.value)} 
                                  size="sm"
                                  placeholder="Prompt"
                    />
                    
                    <Button style={{ textTransform:'none' }}
                                 size="small"
                                 onClick={submit}
                    >
                        <RiAiGenerate2/> Generate
                    </Button>
                </InputGroup>
                }
                { generating &&
                <div>
                <div style={{ width:'300px'}}>
                    <LinearProgress />
                </div>
                <div>
                    <Button size="small" onClick={e => fetch(token,lastAiTag,aiItems)}>Reload</Button>
                </div>
                </div>
                }
            </div>
        </div>

    )
}

export function TabPanel(props) 
{
    const value = props.value 
    const index = props.index

    return (
        <div
            hidden={value !== index}
        >
            {value === index &&
            <>
                {props.children}
            </>
            }
    </div>
    )
}

export const QuestionsModal = (props) => {
    const showModal = props.showModal 
    const setShowModal = props.setShowModal

    const questions = props.questions 
    const setQuestions = props.setQuestions

    const [ selectedTab, setSelectedTab ] = useState(0)

    useEffect( () => {
        if(!showModal)
        {
            return
        }

        setSelectedTab(0)
    },[showModal])

    const handleChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    return (
        <Modal show={showModal} onHide={e => setShowModal(false)} size="xl">
            <Modal.Header closeButton>
                <b>Questions Bank</b>
            </Modal.Header>
            <Modal.Body>
                <div style={{height:'600px', width:'100%'}}>
                    <div style={{height:'100%', width:'120px', float:'left'}}>
                        <Tabs
                            orientation="vertical"
                            variant="scrollable"
                            value={selectedTab}
                            onChange={handleChange}
                            aria-label="Vertical tabs example"
                            sx={{ borderRight: 1, borderColor: 'divider', width:'100%', height:'100%' }}
                        >
                            <Tab label="Bank" sx={{ textTransform:'none' }} /> 
                            <Tab label="AI Generate" sx={{textTransform:'none' }} />
                        </Tabs>
                    </div>
                    <div style={{ height:'100%', width:'calc(100% - 120px)', float:'right' }}>
                        <TabPanel value={selectedTab} index={0}>
                            <QuestionsBank questions={questions} setQuestions={setQuestions}/>
                        </TabPanel>
                        <TabPanel value={selectedTab} index={1}>
                            <AiGenerate questions={questions} setQuestions={setQuestions}/>
                        </TabPanel>
                    </div>
                </div>
             </Modal.Body>
            <Modal.Footer>
                <Button size="small" 
                        sx={{ textTransform:'none'}}
                        onClick={e => setShowModal(false)}
                >
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default function TriviaKing( props )
{
    const dynoCfg = props.dynoCfg 
    const setDynoCfg = props.setDynoCfg
    const selected = props.selected
    const reset = props.reset
    const modalOpen = props.modalOpen

    const [ hashtag, setHashtag ] = useState(null)
    const [ questionTimeout, setQuestionTimeout ] = useState(null)
    const [ answerTimeout, setAnswerTimeout ] = useState(null)
    const [ questionsPerSession, setQuestionsPerSession ] = useState(null)
    const [ questions, setQuestions ] = useState(null)
    const [ font, setFont ] = useState(null)
    const [ variables, setVariables ] = useState(null)

    const [ showModal, setShowModal ] = useState(false)

    const requiredData = [
        hashtag,
        questionTimeout,
        answerTimeout,
        questionsPerSession,
        questions,
        font,
        variables
    ]

    const cfgName = "kingmaker_trivia_king_cfg"

    const reload = () => {
        let properties = dynoCfg.properties
        let cfg = properties[cfgName] || {}

        setHashtag(cfg.hashtag || "")   
        setQuestionTimeout((cfg.question_timeout != null) ? cfg.question_timeout : 60)
        setAnswerTimeout((cfg.answer_timeout != null) ? cfg.answer_timeout : 10 )
        setQuestionsPerSession((cfg.questions_per_session != null) ? cfg.questions_per_session : 5)
        setQuestions(cfg.questions || {})
        setFont(cfg.font || {})
        setVariables(cfg.variables || {})
    }

    useEffect( () => {
        reload()
    },[])

    useEffect( () => {
        if( requiredData.includes(null) )
        {
            return
        }
        
        let data = {}
        data.font = font 
        data.variables = variables
        data.hashtag = hashtag
        data.question_timeout = questionTimeout
        data.answer_timeout = answerTimeout
        data.questions_per_session = questionsPerSession
        data.questions = questions

        let cfg = structuredClone(dynoCfg)
        cfg.properties[cfgName] = data
        setDynoCfg(cfg)
      },[ hashtag, questionTimeout, answerTimeout, questionsPerSession, 
          questions, font, variables ])

    if( requiredData.includes(null) )
    {
        return <></>
    }

    return (
        <>
            <SettingsGroup name="Behaviour">
                <Basic.StringInput name="Hashtag" value={hashtag} setValue={setHashtag}/>
                <Basic.PositiveIntegerInput name="Question timeout" value={questionTimeout} setValue={setQuestionTimeout} />
                <Basic.PositiveIntegerInput name="Answer timeout" value={answerTimeout} setValue={setAnswerTimeout} />
                <Basic.PositiveIntegerInput name="Questions per session" 
                                            value={questionsPerSession} 
                                            setValue={setQuestionsPerSession}
                />
                <Basic.ButtonInput name="Questions bank" onClick={e => setShowModal(true)}/>
            </SettingsGroup> 
            <FontModule font={font} 
                        setFont={setFont}
                        selected={selected}
                        reset={reset}
            />
            <VariableModule variables={variables} 
                            setVariables={setVariables} 
                            variableList={triviaKingVariables}
                            reset={reset}
            />  
            <QuestionsModal showModal={showModal} 
                            setShowModal={setShowModal}
                            questions={questions}
                            setQuestions={setQuestions}
            />
        </>
    )
}

